import _sliced_to_array from "@swc/helpers/src/_sliced_to_array.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button } from "@vfit/shared/atoms";
import { useMediaQuery } from "@vfit/shared/hooks";
import { purify } from "@vfit/shared/themes";
import { Children, useEffect, useState } from "react";
import Tags from "../Tags/tags";
import { DefaultMax, Increment } from "./searchGrid.models";
import { Divider, DividerGrid, ButtonContainer, ItemContainer, GridContainer, SearchContainer } from "./searchGrid.style";
var SearchGrid = function(param) {
    var title = param.title, tags = param.tags, toggleTags = param.toggleTags, elements = param.elements;
    // HTML - CMS purifier
    var ref = _sliced_to_array(purify([
        title
    ]), 1), pTitle = ref[0];
    /**
   * - Setting the max #items to be as mobile DoD
   * - Setting the maxIncrement to be as mobile DoD
   */ var ref1 = useState(DefaultMax.MOBILE), max = ref1[0], setMax = ref1[1];
    var ref2 = useState(Increment.MOBILE), maxIncrement = ref2[0], setMaxIncrement = ref2[1];
    var isDesktop = useMediaQuery("bigDesktop", "min");
    var isTablet = useMediaQuery("tablet", "min");
    useEffect(function() {
        if (isDesktop) {
            // Desktop MAX
            setMax(DefaultMax.DESKTOP);
            setMaxIncrement(Increment.DESKTOP);
        } else if (isTablet) {
            // Tablet MAX
            setMax(DefaultMax.TABLET);
            setMaxIncrement(Increment.TABLET);
        } else {
            setMax(DefaultMax.MOBILE);
            setMaxIncrement(Increment.MOBILE);
        }
    }, [
        isTablet,
        isDesktop
    ]);
    var onHandleClick = function(increment) {
        setMax(function(prev) {
            return prev + increment;
        });
    };
    return /*#__PURE__*/ _jsxs(SearchContainer, {
        children: [
            pTitle && /*#__PURE__*/ _jsx("p", {
                dangerouslySetInnerHTML: {
                    __html: pTitle
                }
            }),
            /*#__PURE__*/ _jsx(Divider, {}),
            tags && /*#__PURE__*/ _jsx(Tags, {
                type: "outlined",
                variant: "white",
                tags: tags,
                toggleTags: toggleTags
            }),
            /*#__PURE__*/ _jsx(DividerGrid, {}),
            /*#__PURE__*/ _jsx(GridContainer, {
                children: Children.toArray(elements === null || elements === void 0 ? void 0 : elements.map(function(el, index) {
                    return index < max ? /*#__PURE__*/ _jsx(ItemContainer, {
                        children: el
                    }) : null;
                }))
            }),
            /*#__PURE__*/ _jsx(DividerGrid, {}),
            /*#__PURE__*/ _jsx(ButtonContainer, {
                children: /*#__PURE__*/ _jsx(Button, {
                    onClick: function() {
                        return onHandleClick(maxIncrement);
                    },
                    children: "Ne Voglio Di PIUUUU"
                })
            })
        ]
    });
};
export default SearchGrid;
